import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

import { frontendAccessRules } from "../utility/accessRules"; // Import the rules

const PrivateRoute = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Find the best-matching access rule for the current path
  const matchedRule = Object.keys(frontendAccessRules).find(route =>
    location.pathname.startsWith(route)
  );

  if (matchedRule) {
    const allowedRoles = frontendAccessRules[matchedRule];
    if (!allowedRoles.includes(auth.user?.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
};


export default PrivateRoute;
